import { payerInvitationRoutes } from 'lib/navigation/helpers/getPayerSignUpPath/getPayerSignUpPath'
import { isAccountingFirm } from 'lib/helpers/isAccountingFirm/isAccountingFirm'
import { BusinessTypeEnum, SignupInterestsEnum } from 'gql/types'

interface GetOnboardingProgressValueParams {
  pathname: string
  businessType?: BusinessTypeEnum
  isSimplifiedFlow?: boolean
  interestedIn?: SignupInterestsEnum[]
}

export const getOnboardingProgressValue = ({
  pathname,
  businessType = BusinessTypeEnum.PAYER,
  isSimplifiedFlow = false,
  interestedIn = [],
}: GetOnboardingProgressValueParams) => {
  const maxProgress = 90
  const hasWorkingCapital = interestedIn.includes(SignupInterestsEnum.WORKING_CAPITAL)
  const defaultSteps = [
    payerInvitationRoutes.product,
    payerInvitationRoutes.businessDetails,
    payerInvitationRoutes.revenue,
    ...(hasWorkingCapital ? [payerInvitationRoutes.capitalNeed] : []),
    payerInvitationRoutes.createAccount,
    '/verify-email',
    '/select-plan',
  ]
  const stepsForAccountingFirm = [
    payerInvitationRoutes.product,
    payerInvitationRoutes.businessDetails,
    payerInvitationRoutes.createAccount,
    '/verify-email',
  ]
  const stepsForSimplifiedFlow = [payerInvitationRoutes.getStarted, payerInvitationRoutes.createAccount]

  const getSteps = () => {
    if (isSimplifiedFlow) {
      return stepsForSimplifiedFlow
    }
    if (isAccountingFirm(businessType)) {
      return stepsForAccountingFirm
    }
    return defaultSteps
  }

  const steps = getSteps()

  const progressStep = Math.floor(maxProgress / steps.length)
  let currentStepIndex = -1

  for (let i = 0; i < steps.length; i++) {
    const step = steps[i]

    if (!step) {
      continue
    }

    if (Array.isArray(step)) {
      for (const subStep of step) {
        if (pathname.includes(subStep)) {
          currentStepIndex = i
          break
        }
      }
    } else if (pathname.includes(step)) {
      currentStepIndex = i
      break
    }
  }

  if (currentStepIndex === -1) {
    return { prev: 0, current: 0 }
  }

  const prev = progressStep * currentStepIndex
  const current = prev + progressStep

  return { prev, current }
}
